var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"my-0 mx-1 pa-1",attrs:{"color":"error"},on:{"click":_vm.logout}},[_vm._v("ログアウト")])}
var staticRenderFns = []

export { render, staticRenderFns }